import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { defaultPaging } from 'clickNgo/configs/crud'
import { IPartner } from 'clickNgo/entities/partner/models'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderFilter, IFilter, Logic } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapPartnerFromPartnerAllDataRegions } from './mapping/mapPartnerFromPartnerAllDataRegions'

export const fetchPartnerRequestList = (
  filters: Array<IFilter | IDataProviderFilter>,
  options?: ICrudFetchOptions
): Promise<IPartner[]> => {
  const partnerCrud = CrudStore.get(CrudStoreItem.PartnerAllData, options?.cacheKey)

  partnerCrud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        logic: Logic.OR,
        filters,
      },
    ],
  })

  partnerCrud.setPaging(options?.paging || defaultPaging)

  return partnerCrud
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result) => {
      if (result && result.items) {
        return result.items.map(mapPartnerFromPartnerAllDataRegions)
      }

      return []
    })
    .catch((e) => {
      Logger.error(e)
      return []
    })
}
